import { LucideIcon } from "lucide-react";
import { ReactNode } from "react";
import { NavLink } from "react-router";

interface DashboardEmptyStateProps {
  icon: LucideIcon;
  message: ReactNode;
  linkTo?: string;
  linkLabel?: ReactNode;
}

export default function DashboardEmptyState({
  icon: Icon,
  message,
  linkTo,
  linkLabel,
}: DashboardEmptyStateProps) {
  return (
    <div className="border-soluud-border flex flex-col items-center gap-3 rounded-xl border-2 border-dashed bg-gray-50 px-4 py-8 text-center">
      <Icon className="text-soluud-text-tertiary h-8 w-8" />
      <p className="text-soluud-text-secondary text-sm">{message}</p>
      {linkTo && linkLabel && (
        <NavLink
          to={linkTo}
          className="bg-soluud-primary/10 text-soluud-primary hover:bg-soluud-primary/20 rounded-md px-4 py-1.5 text-sm font-medium transition-colors"
        >
          {linkLabel}
        </NavLink>
      )}
    </div>
  );
}
